export const VersionHistoryMockData = [
  {
    created: "24 Jul 2020 13:10",
    version: "3",
    updatedBy: "Adrian Sudbury",
    description: "Current - 100 cases processed",
  },
  {
    created: "23 Jul 2020 13:10",
    version: "2",
    updatedBy: "Bob Flem",
    description: "Previous - 80 cases processed",
  },
  {
    created: "21 Jul 2020 13:10",
    version: "1",
    updatedBy: "John Doe",
    description: "Previous - 60 cases processed",
  },
];
